import React from 'react';

export type LandingSectionTitleProps = {
  id?: string;
  kicker?: string;
  title: string;
  subtitle?: string;
  showDivider?: boolean;
  /** Yttre wrapper, t.ex. mb-10 vs mb-12 */
  className?: string;
};

const LandingSectionTitle: React.FC<LandingSectionTitleProps> = ({
  id,
  kicker,
  title,
  subtitle,
  showDivider = true,
  className = 'mb-12 text-center',
}) => (
  <div className={className}>
    {kicker ? (
      <p className="mb-2 text-xs font-semibold uppercase tracking-wider text-purple-400">{kicker}</p>
    ) : null}
    <h2 id={id} className="mb-3 text-3xl font-bold text-white md:text-4xl">
      {title}
    </h2>
    {subtitle ? (
      <p className="mx-auto max-w-2xl text-sm text-slate-400 md:text-base">{subtitle}</p>
    ) : null}
    {showDivider ? <div className="mx-auto mt-6 h-1 w-16 bg-purple-400" /> : null}
  </div>
);

export default LandingSectionTitle;
